<ion-row class="ion-justify-content-center ion-align-items-stretch">
  <ion-col
    size="6"
    [sizeMd]="columnCount"
    *ngFor="let item of node?.items"
    [style.maxWidth]="100 / node?.items.length + '%'">
    <app-img-format
      *ngIf="item.img?.url"
      [src]="item.img.url"
      [aspectRatio]="item.img.ratio"
      [disableLazyLoad]="true"></app-img-format>
  </ion-col>
</ion-row>
